import DriverContractAddBillingModelSelectOption from "./types/driver-contract-add-billing-model-select-option";
import DriverContractAddFormData from "./types/driver-contract-add-form-data";
import DriverContractAddBillingModel from "./types/driver-contract-add-billing-model";
import BillingModel from "../../../../../../common/types/billing-model";
import ContractsTaxiDriverAddParams from "../../../../../../common/services/contracts/taxi-driver/add/contracts-taxi-driver-add-params";

const createContractAddRequestModel = (
  model: DriverContractAddBillingModel,
): BillingModel => {
  switch (model) {
    case DriverContractAddBillingModel.AB:
      return BillingModel.AB;
    case DriverContractAddBillingModel.ABA:
      return BillingModel.ABA;
    case DriverContractAddBillingModel.OTHER:
      return BillingModel.OTHER;
    case DriverContractAddBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createContractAddRequest = (
  formData: DriverContractAddFormData,
  taxiAssociationUuid: string,
): ContractsTaxiDriverAddParams => {
  return {
    validSince: formData.periodOfValidity?.from?.toJSON()!,
    validTo: formData.periodOfValidity?.to?.toJSON()!,
    model: createContractAddRequestModel(formData.billingModel?.value!),
    distanceRate: formData.distanceRate!,
    haltingTimeRate: formData.haltingTimeRate!,
    haltingTimeAfterMinutes: formData.haltingTimeGracePeriodMinutes!,
    taxiDriverAssociationId: taxiAssociationUuid,
    disabled: !formData.isActive,
    description: formData.notes!,
  };
};

const createBillingModelSelectOptions =
  (): DriverContractAddBillingModelSelectOption[] => {
    const selectOptions: DriverContractAddBillingModelSelectOption[] = [
      {
        label: DriverContractAddBillingModel.ABA,
        value: DriverContractAddBillingModel.ABA,
      },
      {
        label: DriverContractAddBillingModel.SABS,
        value: DriverContractAddBillingModel.SABS,
      },
      {
        label: DriverContractAddBillingModel.AB,
        value: DriverContractAddBillingModel.AB,
      },
      {
        label: DriverContractAddBillingModel.OTHER,
        value: DriverContractAddBillingModel.OTHER,
      },
    ];

    return selectOptions;
  };

const driverContractAddFactory = {
  createContractAddRequest,
  createBillingModelSelectOptions,
};

export default driverContractAddFactory;
